export { default } from '@material-ui/core/AccordionSummary';
//# sourceMappingURL=index.js.map